import React, { forwardRef, InputHTMLAttributes } from "react";
import classnames from "classnames";

import "./BaseInput.scss";

interface BaseInputProps extends InputHTMLAttributes<HTMLInputElement> {
  type?: string;
}

export const BaseInput = forwardRef<HTMLInputElement, BaseInputProps>(
  function BaseInput(
    { className, type = "text", hidden, onChange, id, ...attrs },
    ref
  ) {
    return (
      <input
        ref={ref}
        className={classnames(
          "base-input",
          { "base-input--hidden": hidden },
          className
        )}
        type={type}
        onChange={onChange}
        {...attrs}
        data-testid="base-input"
        id={id}
      />
    );
  }
);
